import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(timezone);
dayjs.extend(utc);

export const dateFormat = (date: number, format = 'YYYY.M.D HH:mm'): string => {
  const dateTime = new Date(date);

  return dayjs(dateTime).tz('Asia/Tokyo').format(format);
};

export const currentDateTime = (): number => {
  return dayjs().valueOf();
};
